import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortUsbTypeBIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_316"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_316)">
        <path
          d="M3.89032 7.05604C3.89032 6.90889 4.02961 6.78959 4.20144 6.78959H11.6681C11.8399 6.78959 11.9792 6.90889 11.9792 7.05604V9.987C11.9792 10.1342 11.8399 10.2535 11.6681 10.2535H4.20144C4.02961 10.2535 3.89032 10.1342 3.89032 9.987V7.05604Z"
          fill={color}
        />
        <path
          d="M4.82366 6.25669C4.82366 6.10953 4.96295 5.99024 5.13477 5.99024H7.00144C7.17326 5.99024 7.31255 6.10953 7.31255 6.25669V10.7864C7.31255 10.9335 7.17326 11.0528 7.00144 11.0528H5.13477C4.96295 11.0528 4.82366 10.9335 4.82366 10.7864V6.25669Z"
          fill={color}
        />
        <path
          d="M8.55699 6.25669C8.55699 6.10953 8.69628 5.99024 8.8681 5.99024H10.7348C10.9066 5.99024 11.0459 6.10953 11.0459 6.25669V10.7864C11.0459 10.9335 10.9066 11.0528 10.7348 11.0528H8.8681C8.69628 11.0528 8.55699 10.9335 8.55699 10.7864V6.25669Z"
          fill={color}
        />
        <path
          d="M1 4.98123C1 4.91057 1.03278 4.84279 1.09112 4.79282L3.39777 2.8173C3.45611 2.76733 3.53524 2.73926 3.61776 2.73926H3.96994C4.05965 2.73926 4.145 2.77243 4.20407 2.83025L4.74852 3.36315C4.92453 3.53543 4.78168 3.80506 4.51438 3.80506H4.23641C4.15602 3.80506 4.07874 3.83172 4.02079 3.87944L2.33993 5.26355C2.27892 5.31379 2.24444 5.38314 2.24444 5.45562V13.6637C2.24444 13.8109 2.10516 13.9302 1.93333 13.9302H1.31111C1.13929 13.9302 1 13.8109 1 13.6637V4.98123Z"
          fill={color}
        />
        <path
          d="M15 4.98123C15 4.91057 14.9672 4.84279 14.9089 4.79282L12.6022 2.8173C12.5439 2.76733 12.4648 2.73926 12.3822 2.73926H12.0301C11.9403 2.73926 11.855 2.77243 11.7959 2.83025L11.2515 3.36315C11.0755 3.53543 11.2183 3.80506 11.4856 3.80506H11.7636C11.844 3.80506 11.9213 3.83172 11.9792 3.87944L13.6601 5.26355C13.7211 5.31379 13.7556 5.38314 13.7556 5.45562V13.6637C13.7556 13.8109 13.8948 13.9302 14.0667 13.9302H14.6889C14.8607 13.9302 15 13.8109 15 13.6637V4.98123Z"
          fill={color}
        />
        <path
          d="M14.6889 12.8644C14.8607 12.8644 15 12.9837 15 13.1308V13.6637C15 13.8109 14.8607 13.9302 14.6889 13.9302H1.31111C1.13929 13.9302 1 13.8109 1 13.6637L1 13.1308C1 12.9837 1.13929 12.8644 1.31111 12.8644L14.6889 12.8644Z"
          fill={color}
        />
        <path
          d="M12.2 2.73926C12.3718 2.73926 12.5111 2.85855 12.5111 3.00571V3.53861C12.5111 3.68577 12.3718 3.80506 12.2 3.80506L3.8 3.80506C3.62818 3.80506 3.48889 3.68577 3.48889 3.53861V3.00571C3.48889 2.85855 3.62818 2.73926 3.8 2.73926L12.2 2.73926Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortUsbTypeBIcon.displayName = 'PortUsbTypeBIcon';
